"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_OF_DAY = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const button_1 = __importDefault(require("@kyruus/button"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../../lib/messages"));
exports.TIME_OF_DAY = {
    ALL: 'ALL',
    AM: 'AM',
    PM: 'PM'
};
const ToggleBtn = (_a) => {
    var { isSelected, mode = 'secondary', onClick } = _a, props = __rest(_a, ["isSelected", "mode", "onClick"]);
    return isSelected ? (react_1.default.createElement(styles_1.SelectedBtn, Object.assign({ mode: mode }, props))) : (react_1.default.createElement(button_1.default, Object.assign({ mode: mode, onClick: onClick }, props)));
};
function TimeFilter({ filterBy, onChange }) {
    let selected = null;
    if (filterBy.timeOfDay.has(exports.TIME_OF_DAY.AM))
        selected = exports.TIME_OF_DAY.AM;
    if (filterBy.timeOfDay.has(exports.TIME_OF_DAY.PM))
        selected = exports.TIME_OF_DAY.PM;
    if (filterBy.timeOfDay.size === 0)
        selected = exports.TIME_OF_DAY.ALL;
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "TimeFilter" },
        react_1.default.createElement(styles_1.ButtonGroup, null,
            react_1.default.createElement(ToggleBtn, { isSelected: selected === exports.TIME_OF_DAY.ALL, onClick: () => onChange(new Set([]), exports.TIME_OF_DAY.ALL) },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default['timeOfDay.all']))),
            react_1.default.createElement(ToggleBtn, { isSelected: selected === exports.TIME_OF_DAY.AM, onClick: () => {
                    onChange(new Set([exports.TIME_OF_DAY.AM]), exports.TIME_OF_DAY.AM);
                } },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default['timeOfDay.am']))),
            react_1.default.createElement(ToggleBtn, { isSelected: selected === exports.TIME_OF_DAY.PM, onClick: () => {
                    onChange(new Set([exports.TIME_OF_DAY.PM]), exports.TIME_OF_DAY.PM);
                } },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default['timeOfDay.pm']))))));
}
exports.default = TimeFilter;
//# sourceMappingURL=TimeFilter.js.map